






































import Vue from 'vue';
import TransferGraduationInstitutionInfoForm, {
  InstitutionOption,
  TransferGraduationInstitutionInfoFormEvent,
} from '@/components/forms/TransferGraduationInstitutionInfoForm.vue';
import PipelineMenuWrapper from '@/components/PipelineMenuWrapper.vue';
import BackButton from '@/components/BackButton.vue';
import BottomButton from '@/components/BottomButton.vue';
import pipeline from '@/pipeline';
import { EvaluationTransferGraduation, Institution } from '@/store/modules/admission/state';
import i18n from '@/i18n';
import { Toast } from '@descomplica/vue-components';
import { AnalyticsActions } from '@/store/modules/analytics/actions';

export default Vue.extend({
  components: {
    TransferGraduationInstitutionInfoForm,
    PipelineMenuWrapper,
    BackButton,
    BottomButton,
    Toast,
  },
  data() {
    return {
      form: {
        course: this.$store.getters.transferGraduation?.courseName || '',
        periodYear: this.$store.getters.transferGraduation?.periodYear || '',
        institution: undefined,
      } as TransferGraduationInstitutionInfoFormEvent,
      hasAcceptedToS: this.$store.getters.transferGraduation?.hasAcceptedToS,
      availableInstitutions: [] as InstitutionOption[],
      searchTimeout: null as any,
      isSearching: false,
      error: false,
      loading: false,
    };
  },
  computed: {
    isContinueEnabled(): boolean {
      const { course, periodYear } = this.form;
      return !!course && !!periodYear && !!this.currentInstitution.value && this.hasAcceptedToS;
    },
    evaluationStatus(): string {
      return this.$store.getters.evaluationStatus;
    },
    currentInstitution(): InstitutionOption {
      const { transferGraduation } = this.$store.getters;

      const institution: InstitutionOption = transferGraduation?.institution
        ? {
            key: 'current',
            value: transferGraduation?.institution,
          }
        : ({} as InstitutionOption);

      return this.form.institution || institution;
    },
    fallbackInstitution(): InstitutionOption | null {
      return !this.isSearching ? { key: 'other', value: i18n.t('other') } : null;
    },
    name(): string {
      return this.$store.getters.user?.name || '';
    },
  },
  methods: {
    async continueHandler(): Promise<void> {
      this.loading = true;
      const transferGraduation: EvaluationTransferGraduation = {
        courseName: this.form.course,
        periodYear: this.form.periodYear,
        institution: this.currentInstitution.value,
        hasAcceptedToS: this.hasAcceptedToS,
      };

      await this.$store
        .dispatch('UPDATE_TRANSFER_GRADUATION', { transferGraduation })
        .catch(error => this.errorHandler(error));

      this.$store.dispatch(AnalyticsActions.EVALUATION_SENT);

      pipeline.next();
      this.loading = false;
    },
    inputHandler(event: TransferGraduationInstitutionInfoFormEvent) {
      this.hasAcceptedToS = event.hasAcceptedToS;
      this.form = event;
    },
    searchHandler(input: string) {
      this.isSearching = true;

      clearTimeout(this.searchTimeout);

      this.searchTimeout = setTimeout(async () => {
        await this.$store.dispatch('PULL_AVAILABLE_INSTITUTIONS', { name: input });

        this.availableInstitutions = this.$store.getters.availableInstitutions.map(
          ({ id, name }: Institution) => ({
            key: String(id),
            value: name,
          }),
        );

        this.isSearching = false;
      }, 500);
    },
    errorHandler(error: any) {
      this.error = true;
      setTimeout(() => {
        this.error = false;
        this.loading = false;
      }, 5000);
      throw error;
    },
  },
});
